import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Navbar from './components/Navbar';
import EmployeeManagement from './components/EmployeeManagement';
import LeaveManagement from './components/LeaveManagement';
import PayrollManagement from './components/PayrollManagement';
import PayrollClosureManagement from './components/PayrollClosureManagement';
import DeclarationManagement from './components/DeclarationManagement';
import SelfServicePortal from './components/SelfServicePortal';
import UserModulePermissionsPage from './components/UserModulePermissionsPage';
import Dashboard from './components/Dashboard';
import TimesheetManagement from './components/TimesheetManagement';
import HolidayManagement from './components/HolidayManagement';
import GradeProgressionManagement from './components/GradeProgressionManagement';
import ZKTecoAgentManagement from './components/ZKTecoAgentManagement';
import ZKTecoAttendanceReview from './components/ZKTecoAttendanceReview';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Routes publiques */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route
              path="/"
              element={
                <ProtectedRoute requiredModule="DASHBOARD">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <Dashboard />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />
            {/* Routes protégées */}
            <Route
              path="/employees"
              element={
                <ProtectedRoute requiredModule="EMPLOYEES">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <EmployeeManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/leaves"
              element={
                <ProtectedRoute requiredModule="LEAVES">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <LeaveManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/payrolls"
              element={
                <ProtectedRoute requiredModule="PAYROLLS">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <PayrollManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/payroll-closures"
              element={
                <ProtectedRoute requiredModule="PAYROLL_CLOSURES">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <PayrollClosureManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/declarations"
              element={
                <ProtectedRoute requiredModule="DECLARATIONS">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <DeclarationManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/grade-progression"
              element={
                <ProtectedRoute requiredModule="GRADE_PROGRESSION">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <GradeProgressionManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/timesheets"
              element={
                <ProtectedRoute requiredModule="TIMESHEETS">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <TimesheetManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/holidays"
              element={
                <ProtectedRoute requiredModule="HOLIDAYS">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <HolidayManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/zkteco/agents"
              element={
                <ProtectedRoute requiredModule="ZKTECO_AGENTS">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <ZKTecoAgentManagement />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/zkteco/attendance"
              element={
                <ProtectedRoute requiredModule="ZKTECO_ATTENDANCE">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <ZKTecoAttendanceReview />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/mon-espace"
              element={
                <ProtectedRoute requiredModule="SELF_SERVICE">
                  <>
                    <Navbar />
                    <main className="app-main">
                      <SelfServicePortal />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users/:userId/permissions"
              element={
                <ProtectedRoute requiredRoles={['ROLE_RH']}>
                  <>
                    <Navbar />
                    <main className="app-main">
                      <UserModulePermissionsPage />
                    </main>
                  </>
                </ProtectedRoute>
              }
            />
            
            
            {/* Redirection par défaut */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
